import { combineReducers } from 'redux'
import financeReducer from './financeBusiness/finance.reducer'
const rootReducer = combineReducers({ financeReducer })

export default rootReducer